import React from 'react';
import { format, parseISO } from 'date-fns';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { actions as calendarActions, getModuleState } from 'services/calendar';
import {
  SContainer,
  STime,
  STitle,
  SInfo,
  SAbsence,
  SNote,
  SUserName,
  STimeBox,
} from '../styled/eventDay.js';
import { Box as MuiBox, Typography as MuiTypography, useTheme } from '@mui/material';
import { Icon } from 'components/ui';
import { Videocam as VideocamIcon } from '@mui/icons-material';
import { meetingTypesData } from 'lib/enums/meetingTypes.js';
import { useStatusObject } from 'pages/SchedulePage/utils/statusObject.js';
import { eventUserStatuses } from 'lib/enums/eventUserStatuses';

// const currentDate = new Date();
function EventDay(props) {
  const { event } = props;
  const { t } = useTranslation();
  const calendarState = useSelector(getModuleState);
  const dispatch = useDispatch();
  const { selectedEvent } = calendarState;
  const theme = useTheme()

  const statusObject = useStatusObject()
  const isSelected = selectedEvent?.eventId === event?.id;
  const disabled = false;

  /* const getFormattedTitle = (title) => {
    if (title?.length > 10) {
      return title.slice(0, 11) + '...';
    }
    return title;
  }; */

  const getBackgroundColorForContainer = (event) => {
    return event.status === eventUserStatuses.booked
      ? statusObject.APPROVED.hexBgColor
      : statusObject.AWAITING.hexBgColor;
  };
  
  const getBorderColorForContainer = (event) => {
    return event.status === eventUserStatuses.booked
      ? statusObject.APPROVED.hexColor
      : statusObject.AWAITING.hexColor;
  };

  const titleText = `${event?.patientParticipant?.patient?.name?.firstName?.[0]} ${event?.patientParticipant?.patient?.name?.lastName}`;

  return (
    <>
      {event?.__typename === 'GqlPractitionerAbsence' ? (
        <SAbsence className="absence">
          <STitle isSelected={true} style={{ marginBottom: 5 }}>
            {t('Unavailable')}
          </STitle>
          <STime isSelected={true}>
            {event.startDate && event.endDate
              ? `${format(parseISO(event.startDate), 'HH:mm')} - ${format(
                  parseISO(event.endDate),
                  'HH:mm'
                )}`
              : '-'}
          </STime>
          <SNote isSelected={true}>{event?.title}</SNote>
        </SAbsence>
      ) : (
        <SContainer
          isSelected={isSelected}
          backgroundColor={getBackgroundColorForContainer(event)}
          borderColor={getBorderColorForContainer(event)}
          disabled={disabled}
          onMouseEnter={() => {
            dispatch(
              calendarActions.highlightEvent({
                eventId: event.id,
              })
            );
          }}
          onMouseLeave={() => {
            dispatch(calendarActions.highlightEvent({ eventId: null }));
          }}
        >
          <SInfo isSelected={isSelected} event={event}>
            <MuiBox
              display="flex"
              flexDirection="column"
              alignItems="center"
              width="100%"
            >
              <SUserName>{titleText}</SUserName>
            </MuiBox>

            <MuiBox>
              <MuiTypography
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: 10,
                  fontWeight: 500,
                  color: theme.palette.colors.black100,
                  marginTop: 4,
                }}
              >
                {t(meetingTypesData[event?.eventType]?.label)}
                {event?.isOnline ? (
                  <VideocamIcon
                    style={{
                      width: 16,
                      height: 16,
                      padding: '0 2 0',
                      color: disabled ? theme.palette.colors.white : theme.palette.colors.black,
                    }}
                  />
                ) : (
                  ''
                )}
              </MuiTypography>
            </MuiBox>
            <STimeBox>
              {event.startDate && event.endDate
                ? `${format(parseISO(event.startDate), 'HH:mm')} - ${format(
                    parseISO(event.endDate),
                    'HH:mm'
                  )}`
                : '-'}
            </STimeBox>
            <STitle>
              <Icon
                icon="map-marker-alt"
                type="fal"
                style={{ fontSize: 10, marginRight: 5 }}
              />
              {event?.isOnline ? t('Online') : t('On-site')}
            </STitle>
          </SInfo>
        </SContainer>
      )}
    </>
  );
}

export default EventDay;
